import * as React from 'react'
import Box from '@mui/material/Box'

type Props = {
  children: React.ReactNode
}

export function ListContainer(props: Props) {
  const { children } = props

  return (
    <Box
      height="100%"
      overflow="hidden auto"
      display="flex"
      flexDirection="column"
      mt={1}
      mb={-1.5}
      mr={-1.5}
      pr={1}
      pt={1}
    >
      {children}
    </Box>
  )
}
